import { AllCompaniesPage } from './AllCompanies';
import { createAllCompaniesHandle } from './handle';

export default {
  Component: AllCompaniesPage,
  createHandle: createAllCompaniesHandle
};
